/**
 * SFrame252 — Final accounting supplements & paper trail guidance.
 */

import { useParams, Link } from 'react-router-dom';
import ClosePhaseChrome from './ClosePhaseChrome';

export default function SFrame252() {
  const { estateId } = useParams<{ estateId: string }>();
  const suffix = estateId ? `/${estateId}` : '';

  return (
    <ClosePhaseChrome
      estateId={estateId}
      title="Final accounting supplements"
      subtitle="Use this checklist alongside the ledger on the previous screen to assemble court-ready or beneficiary-ready packages."
    >
      <ul className="list-disc list-inside text-sm text-slate-700 space-y-2 max-w-3xl">
        <li>Bank statements for the full life of the estate account.</li>
        <li>Cancelled checks or ACH confirmations for every distribution.</li>
        <li>Receipts for professional fees, taxes paid, and recurring expenses.</li>
        <li>Reconciliation notes explaining any timing differences between ledger and bank.</li>
      </ul>
      <div className="flex flex-wrap gap-4 text-sm print:hidden">
        <Link to={`/sframe-251${suffix}`} className="text-blue-800 hover:underline">
          ← Financial reconciliation
        </Link>
        <Link to={`/sframe-253${suffix}`} className="font-medium text-blue-800 hover:underline">
          Beneficiary approvals →
        </Link>
      </div>
    </ClosePhaseChrome>
  );
}
